import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { DEVICE_ORIENTATION } from "../../shared/constants/constants";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    SofyAuth: environment.AUTH_TOKEN,
  }),
};

@Injectable({
  providedIn: "root",
})
export class DeviceService {
  private currentDeviceOrientation = DEVICE_ORIENTATION.PORTRAIT;
  currentDeviceOrientationSubject: BehaviorSubject<string> =
    new BehaviorSubject(this.currentDeviceOrientation);

  openDeviceSettingsSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  devicePreferences: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {}

  setDeviceOrientation(orientation: string): void {
    this.currentDeviceOrientation = orientation;
    this.currentDeviceOrientationSubject.next(this.currentDeviceOrientation);
  }

  setDeviceSettings(additionalSettingsState: any): void {
    this.openDeviceSettingsSubject.next(additionalSettingsState);
  }

  getDevicePreferences(deviceSerial: string): Observable<any> {
    return this.http.get<any>(
      environment.baseUrl + "/device-microservice/device/" + deviceSerial + "/preferences",
      httpOptions
    );
  }
}
